var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResultIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_20",
    "data-name": "\\uADF8\\uB8F9 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_160",
    "data-name": "\\uC0AC\\uAC01\\uD615 160",
    width: 80,
    height: 80,
    fill: "#ddd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19",
    "data-name": "\\uADF8\\uB8F9 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M76.339,23.695,70.85,29.2a32.87,32.87,0,1,1-8.631-13.233L67.27,10.9A39.951,39.951,0,0,0,11.686,68.284,39.95,39.95,0,0,0,76.659,24.429c-.1-.246-.212-.491-.32-.734",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2",
    "data-name": "\\uD328\\uC2A4 2",
    d: "M84.22,72.324a2.569,2.569,0,0,1-3.64,0L64.944,56.649a4.756,4.756,0,1,1,6.717-6.734L82.4,60.681l31.934-32.016a4.756,4.756,0,1,1,6.717,6.734Z",
    transform: "translate(-42.442 -18.188)",
    fill: "#35ade3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultIco);
export default __webpack_public_path__ + "static/media/result_ico.71f856fdd18fa5fd58fd9fe7921d3e0f.svg";
export { ForwardRef as ReactComponent };